import { defineStore } from "pinia";
import { computed, ref } from "vue";

// Lets an unrelated part of the app close the currently active onboarding tour. v-onboarding's
// overlay is `pointer-events: none` with no click-outside-to-close, so it never learns that
// something else — e.g. Frontegg's AdminPortal, opened from the profile menu the "Profile" step
// spotlights — has opened on top of it. Left alone, the tour panel stays mounted underneath,
// crowded into a barely-usable sliver rather than actually closing.
export type TourKind = "welcome";

export const useFlowGuideCoordinationStore = defineStore("flowGuideCoordinationStore", () => {
  // state
  const activeTour = ref<{ kind: TourKind; finish: () => void } | null>(null);

  // actions
  const registerActiveTour = (finish: () => void, kind: TourKind = "welcome") => {
    activeTour.value = { kind, finish };
  };

  // Identity-checked: a tour unmounting must not clear another tour's registration.
  const unregisterActiveTour = (finish?: () => void) => {
    if (!finish || activeTour.value?.finish === finish) activeTour.value = null;
  };

  const closeActiveTour = () => {
    activeTour.value?.finish();
  };

  // computed
  const isWelcomeTourActive = computed(() => activeTour.value?.kind === "welcome");

  return {
    // actions
    registerActiveTour,
    unregisterActiveTour,
    closeActiveTour,

    // computed
    isWelcomeTourActive,
  };
});
